import { Download } from "@mui/icons-material";
import { Button, CircularProgress, Tooltip, Typography } from "@mui/material";
import React from "react";
import {
  ICSVExportPluginProps,
  ICSVExportPluginonPagination,
  ICSVDataFormat,
} from "./interfaces/ICSVExportPluginProps";
import Excel from "exceljs";
import FileServer from "file-saver";
import moment from "moment";
import { convertToIST } from "../../../../helpers/convertDate";

export const CSVExportPluginonPaginationComplaint: React.FC<
  ICSVExportPluginonPagination
> = (props) => {
  const { columns, filePrefixName, onExportButtonClick } = props;
  const [loading, setLoading] = React.useState(false);

  const generateExcelSheet = async (content: ICSVDataFormat[]) => {
    const workbook = new Excel.Workbook();
    const sheet = workbook.addWorksheet("Sheet1", {
      views: [{ state: "frozen", ySplit: 1 }],
    });
    const generatedColumns = [];

    for (let column of columns) {
      generatedColumns.push({
        header: column.columnName,
        key: column.columnName,
        width: column.width || 10,
      });
    }
    sheet.columns = generatedColumns;
    const rowsList: any = [];

    for (let row of content) {
      const finalRow = [];

      for (let col of columns) {
        let data = row[col.fieldName];

        // Format selected_date in UTC as 'YYYY/MM/DD'
        if (col.fieldName === "selected_date" && typeof data === "string") {
          data = moment.utc(data).format("YYYY/MM/DD");
        } else if (
          typeof data === "string" &&
          moment(data, moment.ISO_8601, true).isValid()
        ) {
          // Apply convertToIST to other date fields
          data = convertToIST(data);
        }

        // Special handling for additional_details field
        if ((col.fieldName === "additional_details" || col.fieldName === "additional_amount_details") && Array.isArray(data)) {
          // Convert array of objects to a single object
          const combinedObject = (data as any[]).reduce((acc: Record<string, any>, curr: Record<string, any>) => {
            return { ...acc, ...curr };
          }, {});
          // Convert to JSON string
          data = JSON.stringify(combinedObject);
        } else if (Array.isArray(data)) {
          // Handle other array fields
          data = data.join(", ");
        }

        finalRow.push(data);
      }

      rowsList.push(finalRow);
    }

    const date = moment(new Date()).format("DD/MM/YYYY");
    sheet.addRows(rowsList);
    const buffer = await workbook.xlsx.writeBuffer();
    FileServer.saveAs(new Blob([buffer]), `${filePrefixName}-${date}.xlsx`);
  };

  const handleExportClick = async () => {
    try {
      setLoading(true);
      const data = await onExportButtonClick();
      await generateExcelSheet(data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Download Excel file(.csv)">
        <Button
          variant="text"
          sx={{ minWidth: "fit-content" }}
          onClick={handleExportClick}
          disabled={loading}
        >
          {loading ? (
            <>
              <CircularProgress size={18} sx={{ mr: 1 }} />{" "}
              <Typography color="primary">Please wait...</Typography>
            </>
          ) : (
            <Download color={"primary"} />
          )}
        </Button>
      </Tooltip>
    </>
  );
};
